const getObjectValue = <T>(value: T | null | undefined): T => value ?? ({} as T);

export default getObjectValue;
